(() => {
  function init(root = document) {
    root.querySelectorAll('[data-product-rail-section]').forEach(section => {
      if (section.dataset.railInitialized) return;
      section.dataset.railInitialized = 'true';
      const rail = section.querySelector('[data-product-rail]');
      const controls = section.querySelector('[data-rail-controls]');
      const previous = section.querySelector('[data-rail-prev]');
      const next = section.querySelector('[data-rail-next]');
      const update = () => {
        const hasOverflow = rail.scrollWidth > rail.clientWidth + 2;
        controls.hidden = !hasOverflow;
        previous.disabled = rail.scrollLeft < 2;
        next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
      };
      const move = direction => {
        const card = rail.querySelector('.product-card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        const distance = card.getBoundingClientRect().width + gap;
        rail.scrollBy({ left: direction * distance, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      rail.addEventListener('scroll', update, { passive: true });
      rail.addEventListener('keydown', event => {
        if (event.target !== rail) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          move(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      const observer = new ResizeObserver(update);
      observer.observe(rail);
      const editorSection = section.closest('.shopify-section') || section;
      editorSection.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
      update();
    });
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const form = section.querySelector('.product-form');
      const variants = JSON.parse(section.querySelector('[data-product-variants]').textContent);
      const selects = [...form.querySelectorAll('[data-option-index]')];
      const fields = [...form.querySelectorAll('[data-custom-field]')];
      const id = form.querySelector('[data-variant-id]');
      const submit = form.querySelector('[data-add-to-cart]');
      const submitLabel = submit.querySelector('[data-add-label]');
      const price = section.querySelector('[data-product-price]');
      const delivery = section.querySelector('[data-delivery-estimate]');
      const gallery = section.querySelector('[data-gallery-main]');
      if (gallery) gallery.dataset.originalAlt = gallery.alt;
      const thumbnails = [...section.querySelectorAll('[data-gallery-thumbnail]')];
      function showImage(src, alt) {
        if (!gallery || !src) return;
        gallery.src = src;
        gallery.removeAttribute('srcset');
        gallery.alt = alt || gallery.dataset.originalAlt || '';
        thumbnails.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.src === src)));
      }
      function syncFields() {
        const chosen = selects.map(select => select.value);
        let personalised = false;
        fields.forEach(field => {
          const gated = field.dataset.gated === 'true';
          const active = !gated || chosen[Number(field.dataset.linkedOptionIndex)] === field.dataset.linkedPersonalisedValue;
          if (gated && active) personalised = true;
          field.hidden = !active;
          const select = field.querySelector('[data-custom-select]');
          if (select) {
            const text = field.querySelector('[data-custom-text]');
            const textLabel = field.querySelector('[data-custom-text-label]');
            const mirror = field.querySelector('[data-custom-value]');
            const custom = active && select.value === '__custom';
            select.disabled = !active;
            select.required = gated && active;
            text.hidden = !custom;
            textLabel.hidden = !custom;
            text.disabled = !custom;
            text.required = gated && custom;
            mirror.disabled = !active;
            mirror.value = active ? (custom ? text.value : select.value) : '';
          } else {
            const text = field.querySelector('input');
            text.disabled = !active;
            text.required = gated && active;
          }
        });
        delivery.textContent = personalised && delivery.dataset.bespoke ? delivery.dataset.bespoke : delivery.dataset.standard;
      }
      function syncVariant(updateUrl = false) {
        const chosen = selects.map(select => select.value);
        const match = selects.length ? variants.find(variant => chosen.every((value, index) => value === variant.options[index])) : variants[0];
        syncFields();
        id.disabled = !match;
        id.value = match ? match.id : '';
        submit.disabled = !match || !match.available;
        submitLabel.textContent = !match ? 'Niet beschikbaar' : match.available ? 'In winkelwagen' : 'Uitverkocht';
        section.querySelector('[data-variant-message]').textContent = match ? '' : 'Deze combinatie is niet beschikbaar. Kies een andere uitvoering.';
        price.textContent = match ? match.price : 'Niet beschikbaar';
        if (match && match.image) showImage(match.image, match.imageAlt);
        if (updateUrl) {
          const url = new URL(window.location.href);
          if (match) url.searchParams.set('variant', match.id);
          else url.searchParams.delete('variant');
          window.history.replaceState(window.history.state, '', url);
        }
      }
      selects.forEach(select => select.addEventListener('change', () => syncVariant(true)));
      fields.forEach(field => {
        field.addEventListener('change', syncFields);
        field.addEventListener('input', syncFields);
      });
      thumbnails.forEach(button => button.addEventListener('click', () => showImage(button.dataset.src, button.dataset.alt)));
      form.addEventListener('submit', event => {
        syncFields();
        if (submit.disabled || !form.reportValidity()) event.preventDefault();
      });
      syncVariant();
    });
    root.querySelectorAll('[data-tracking-form]').forEach(form => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      form.addEventListener('submit', event => {
        event.preventDefault();
        const input = form.querySelector('input');
        if (!input.value.trim()) { input.setCustomValidity('Vul je trackingnummer in.'); input.reportValidity(); return; }
        window.open('https://t.17track.net/nl#nums=' + encodeURIComponent(input.value.trim()), '_blank', 'noopener,noreferrer');
      });
      form.querySelector('input').addEventListener('input', event => event.target.setCustomValidity(''));
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
